import { Component, OnInit } from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {UserStoreService} from '../../../core/services/user-store.service';
import {ProductosService} from '../../../core/services/nuevaLogica/productos/productos.service';
import * as $ from 'jquery';
import {CarritoService} from '../../../core/services/nuevaLogica/checkout/carrito.service';
import {ToastrService} from 'ngx-toastr';

@Component({
  selector: 'app-detalle-producto',
  templateUrl: './detalle-producto.component.html',
  styleUrls: ['./detalle-producto.component.scss']
})
export class DetalleProductoComponent implements OnInit {
  public producto: any;
  counter = 1;
  selectedSize: any = '';
  tokenIsValid = false;
  sugeridos = [];
  benefict: any;
  slideConfig = {
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    fade: true,
  };

  constructor(private route: ActivatedRoute,
              private router: Router,
              private loginService: UserStoreService,
              private productsService: ProductosService,
              private toastrService: ToastrService,
              private carritoService: CarritoService) {
    this.route.params.subscribe(params => this.getProducto(params.producto));
  }

  public slideNavConfig = {
    vertical: false,
    slidesToShow: 3,
    slidesToScroll: 1,
    asNavFor: '.product-slick',
    arrows: false,
    dots: false,
    focusOnSelect: true
  };

  ngOnInit() {
    this.tokenIsValid = this.loginService.validToken();
    /*if (this.tokenIsValid) {
      this.getUsuarioDescuento();
    }*/
  }

  getProducto(urlProducto: string) {
    this.productsService.getByDescripcion(urlProducto).subscribe(product => this.producto = product);
  }

  /*getUsuarioDescuento() {
    this.benefictService.getBeneficiarioByIdUsuario().subscribe(data => {
      this.descuento = data[0].idEstadoBeneficio || false;
      this.benefict = data;
    });
  }*/

  onMouseOver(): void {
    document.getElementById('p-zoom').classList.add('product-zoom');
  }

  onMouseOut(): void {
    document.getElementById('p-zoom').classList.remove('product-zoom');
  }

  decrementIncrement(increment: boolean) {
    if (increment) {
      this.counter += 1;
    } else {
      this.counter -= 1;
    }
  }

  public mobileSidebar() {
    $('.collection-filter').css('left', '-15px');
  }

  // Add to cart
  addToCart(redirect: boolean) {
    this.carritoService.updateCarrito({
      precio: this.getPrecioVenta(this.producto),
      nombre: this.producto.nombre,
      idTallaSeleccionada: this.selectedSize.id,
      talla: this.selectedSize.talla,
      imagen: this.producto.imagenes[0].url,
      cantidad: this.counter,
      idDescuento: this.producto.idDescuento
    });
    if (redirect) {
      this.router.navigate(['/checkout/pago']);
    } else {
      this.toastrService.success('Producto añadido al carrito');
    }
  }

  getPrecioVenta(producto): number {
    if (!producto.idDescuento) {
      return producto.precioVenta;
    } else {
      if (producto.idTipoDescuento === 1) {
        return producto.precioVenta - ((producto.precioVenta * producto.descuento) / 100);
      }
      return producto.precioVenta - producto.descuento;
    }
  }
}
